// Preserve legal, payment, and companion URLs within the platform architecture.
const routes = [
  { path: "/", exact: true, component: "Home", modern: true },
  {
    path: "/solutions/individuals",
    exact: true,
    component: "Individuals",
    modern: true,
  },
  {
    path: "/solutions/:slug",
    exact: true,
    component: "Solutions",
    modern: true,
  },
  {
    path: "/use-cases/:slug",
    exact: true,
    component: "UseCases",
    modern: true,
  },
  { path: "/platform", exact: false, component: "Platform", modern: true },
  { path: "/evidence", exact: true, component: "Evidence", modern: true },
  { path: "/resources", exact: true, component: "Resources", modern: true },
  { path: "/about", exact: true, component: "About", modern: true },
  { path: "/contact", exact: true, component: "Contact", modern: true },
  {
    path: ["/sara", "/irene"],
    exact: true,
    component: "Companion",
    modern: true,
  },
  { path: "/Policy", exact: true, component: "Policy", modern: false },
  { path: "/Terms", exact: true, component: "Terms", modern: false },
  { path: "/Imprint", exact: true, component: "Imprint", modern: false },
  { path: "/success", exact: true, component: "Success", modern: false },
  { path: "/cancel", exact: true, component: "Cancel", modern: false },
];
export default routes;
